module.exports = __webpack_public_path__ + "static/media/Internationalpic1@3x.4d08ca11.png";